import * as React from 'react';
import { useIntl } from 'react-intl';

import { FilterItemCheckbox } from '@notino/react-styleguide';

import { useTrackingContext } from '@context/tracking/TrackingContext';

import { sortFilterBarMessages } from '../../messages';
import {
  useReviewFilterActions,
  useReviewFiltersStore,
} from '../../Stores/filtersStore';
import { trackFiltration } from '../tracking';

export const ContentTypesFilterContent: React.FC = () => {
  const filters = useReviewFiltersStore((state) => state.filtersData);
  const contentTypes = filters?.contentTypes || [];
  const selections = useReviewFiltersStore(
    (state) => state.temporarySelections
  );
  const { toggleSelection } = useReviewFilterActions();

  const { formatMessage } = useIntl();

  const { getTimeFromInit } = useTrackingContext();

  if (!contentTypes.length) {
    return null;
  }

  const onChange = (type: string) => {
    toggleSelection(type);
    trackFiltration({
      interaction: 'click_add',
      timing: getTimeFromInit(),
      name: type,
      action: 'filtration_used',
      type: 'content_type',
    });
  };

  return (
    <>
      {contentTypes
        .filter(
          ({ count, type }) =>
            (count ?? 0) > 0 &&
            `contentType${type ?? ''}` in sortFilterBarMessages
        )
        .map(({ count, type }) => {
          return (
            <FilterItemCheckbox
              key={type}
              isChecked={selections.includes(type ?? '')}
              onChange={() => onChange(type ?? '')}
              count={count ?? undefined}
            >
              <span>
                {formatMessage(
                  sortFilterBarMessages[`contentType${type ?? ''}`]
                )}
              </span>
            </FilterItemCheckbox>
          );
        })}
    </>
  );
};
